import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function Annulee() {
  return (
    <div className="max-w-lg mx-auto px-5 pt-16 pb-16 text-center">
      <XCircle size={48} className="text-white/30 mx-auto mb-4" />
      <h1 className="font-display font-black text-2xl md:text-3xl tracking-tight mb-3">Paiement annulé</h1>
      <p className="text-white/60 leading-relaxed">
        Ta commande n'a pas été validée et aucun montant n'a été débité. Ton panier est toujours là, tu peux réessayer
        à tout moment.
      </p>
      <Link to="/panier" className="btn-solid inline-flex !py-3 !px-6 mt-8">Retour au panier</Link>
    </div>
  );
}
